import { randexp } from 'randexp';
import { InjectableClass } from '@fino/lib-injection';
import { Ibans, Chars } from './DataGenerator.constants';
import superb from 'superb';
import superheroes from 'superheroes';
// import IBAN from 'iban';

export class DataGenerator extends InjectableClass {
  constructor() {
    'ngInject';
    super({});
  }

  generate(options, modifier) {
    // Handle field type:
    // Possible values are 'radio', 'checkbox' or 'text'
    switch (options.type) {
      case 'radio': {
        // Return given field value
        return options.value;
      }
      case 'checkbox': {
        // Return true or false
       return !!this.getRandomInteger(0, 1);
      }
      case 'text': {
        // // Handle fields with name separatly to generate readable names
        // if (/(.*)name/i.test(options.name)) {
        //   return this.generateReadable(options);
        // }

        // Handle field name with default handling of field validation.
        // Return the result value if it is defined, otherwise customize
        // the field pattern regarding to the target field.
        const name = options.name.toLowerCase();
        const value = this.generateByType(name, options);
        if (value !== void 0) {
          return value;
        }
        break;
      }
      case 'date': {
        // Create a date respecting the possible given minimum and maximum date
        if (options.min && options.max) {
          return this.getRandomDate(new Date(options.min), new Date(options.max));
        }

        if (options.min) {
          // Add 2 to 5 days to the minimum date
          let minDate = new Date(options.min);
          return new Date(minDate.getTime() + (this.getRandomInteger(2, 5) * 86400000));
        }

        if (options.max) {
          // Subtract 2 to 5 days from the maximum date
          let maxDate = new Date(options.max);
          return new Date(maxDate.getTime() - (this.getRandomInteger(2, 5) * 86400000));
        }

        return new Date();
      }
      case 'select': {
        if (options.value) {
          return options.value;
        }
        return this.getSelectValue(options, modifier);
      }
    }

    // Generate random data
    return this.generateByRegex(
      new RegExp(options.pattern)
    );
  }

  generateByType(type, options) {
    switch (type) {
      case 'firstName': {
        return this.capitalize(superb());
      }
      case 'lastName': {
        return superheroes.random();
      }
      case 'birthday':
      case 'birthdate': {
        // Overwrite birthdate pattern
        if (options.fullAged) {
          const now = new Date();
          return this.getRandomDate(new Date(1900, 0, 1), new Date(now.getFullYear() - 18, 0, 1));
        }
        options.pattern = '(0[1-9]|[12][0-9]|3[01])[\.](0[1-9]|1[012])[\.](19|20)[0-9]{2}';
        break;
      }
      case 'email': {
        // Overwrite email pattern
        options.pattern = '[a-z]{3,10}@[a-z]{3,5}[\.](de|net|com|digital)';
        break;
      }
      case 'address': {
        // Overwrite address pattern
        options.pattern = `[A-Z][a-z]{${options.minLength},${options.maxLength}} [1-9]{1,3}`;
        break;
      }
      case 'postcode': {
        // Overwrite postcode pattern
        options.pattern = '[0-9]{5}';
        break;
      }
      case 'bic':
      case 'bankcode': {
        // Overwrite bankcode pattern
        options.pattern = '([a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)';
        break;
      }
      default: {
        // Handle given validate value
        if (options.validate) {
          if (/iban/.test(options.validate)) {
            // Use valid example ibans
            return Ibans[Math.floor(Math.random() * Ibans.length)];
          }
          return this.generateByType(options.validate, options);
        }

        // Fallback pattern: Create readable random text
        if (!options.pattern) {
          // options.pattern = `[A-Z][a-z]{${options.minLength},${options.maxLength - 1}}`;
          return this.generateReadable(options);
        }
        break;
      }
    }
  }

  generateByRegex(regex) {
    return randexp(regex);
  }

  generateReadable(options, template = 'Cvccvc') {
    // Adjust template accordingly to given options
    if (options) {
      // Handle minimum length
      if (options.minLength) {
        while (options.minLength > template.length) {
          template += 'cvc';
        }
      }
      // Handle maximal length
      if (options.maxLength && options.maxLength < template.length) {
        template = template.substr(0, options.maxLength);
      }
    }

    let name = '';
    let possible;
    for (let i = 0, len = template.length; i < len; i++) {
      possible = Chars[template.charAt(i)];
      name += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return name;
  }

  getSelectValue(options, modifier) {
    let value = options.selectables[this.getRandomInteger(0, options.selectables.length - 1)];

    if (options.modelKey) {
      value = value[options.modelKey];
    }

    if (modifier) {
      value = modifier(value);
    }
    if (options.multiple) {
      return [value];
    }
    return value;
  }

  getRandomInteger(min = 0, max = 1) {
    return Math.round((Math.random() * (max - min))) + min;
  }

  getRandomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  }

  //
  // Helpers
  //

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
